import gruserSaga from '@wix/da-gruser-shared/pkg/redux/sagas';
import measuredCookieSaga from '@wix/da-hooks/pkg/useMeasureElement/redux/saga';
import compliantLocalStorageSaga from '@wix/da-react-context/pkg/compliantLocalStorage/redux/saga';
import appMountCompliantLocalStorageSaga from '../compliantLocalStorage/saga';
import publicSessionSaga from '../../publicSession/saga';
import commentEditorSagaNew from '../../CommentEditor/redux/saga';
import commentThreadSaga from '../../CommentThread/saga';
import emoteSelectorSaga from '../../EmoteSelector/redux/saga';
import watchButtonSaga from '../../WatchButton/redux/saga';
import userAvatarSaga from '../../User/AvatarPopover/saga';
import streamSagas from '../../Stream/sagas';
import usersSaga from '../users/saga';
import deviationsSaga from '../deviations/saga';
import commissionsSaga from '../commissions/saga';
import loggedOutSaga from '../loggedout/saga';
import pollEditSaga from '../../PollEditPopup/redux/sagas';
import collectionPanelSaga from '../../CollectionPanel/redux/saga';
import firstTimeFlagsSaga from '../firstTimeFlags/saga';
import siteHeaderSaga from '../../SiteHeader/redux/saga';
import duperbrowseSaga from '../../Duperbrowse/redux/saga';
import deviationBackgroundSaga from '../../DeviationBackground/redux/saga';
import moderationSaga from '../../Moderation/redux/saga';
import whoSaga from '../../Who/redux/saga';
import deviationPageSaga from '../../DeviationPage/redux/saga';
import addToGroupSaga from '../../AddToGroupsPanel/redux/saga';
import groupsSaga from '../../redux/groups/saga';
import watchSuggestionsSaga from '../../WatchSuggestions/redux/saga';
import pollViewSaga from '../../PollView/redux/saga';
import artBrandedPopupSaga from '../../ArtBrandedPopup/redux/saga';
import biSaga from '../../biLogger/redux/saga';
import hubSaga from '../hub/saga';
import modalSaga from '../../Modals/redux/saga';
import messagesSaga from '../messages/saga';
import coreBadgeSaga from '../../coreBadge/redux/saga';
import networkbarSaga from '../../NetworkBar/redux/saga';
import simpleXHRSaga from '../../simpleXHR/saga';
import favouritedByModalSaga from '../../FavouritedByModal/redux/saga';
import uploadsSaga from '../uploads/saga';
import tagInputSaga from '../../TagInput/redux/saga';
import reportPageSaga from '../../ReportPage/redux/saga';
import topicSaga from '../topic/saga';
import birthdayPopupSaga from '../../BirthdayPopup/redux/saga';
import pwaSaga from '../pwa/saga';
import boostSaga from '../../ActionBar/buttons/BoostButton/modals/BoostCoreModal/redux/sagas';
import chooseAvatarModalSaga from '../../CommentBox/lego/ChooseAvatarModal/saga';

export const sagas = [
  publicSessionSaga,
  commentEditorSagaNew,
  commentThreadSaga,
  usersSaga,
  deviationsSaga,
  commissionsSaga,
  emoteSelectorSaga,
  watchButtonSaga,
  userAvatarSaga,
  pollEditSaga,
  collectionPanelSaga,
  loggedOutSaga,
  firstTimeFlagsSaga,
  measuredCookieSaga,
  siteHeaderSaga,
  duperbrowseSaga,
  deviationBackgroundSaga,
  moderationSaga,
  whoSaga,
  deviationPageSaga,
  addToGroupSaga,
  groupsSaga,
  watchSuggestionsSaga,
  pollViewSaga,
  artBrandedPopupSaga,
  biSaga,
  hubSaga,
  modalSaga,
  messagesSaga,
  compliantLocalStorageSaga,
  appMountCompliantLocalStorageSaga,
  coreBadgeSaga,
  networkbarSaga,
  simpleXHRSaga,
  favouritedByModalSaga,
  uploadsSaga,
  tagInputSaga,
  reportPageSaga,
  topicSaga,
  birthdayPopupSaga,
  gruserSaga,
  pwaSaga,
  boostSaga,
  chooseAvatarModalSaga,
  ...streamSagas,
];
